import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { ImageWithFocalPoint } from "./ImageWithFocalPoint";
import styles from "./FocalPointPreviewSection.module.less";
import { FocalPoint } from "./FocalPointDialog";

export type FocalPointPreviewSectionProps = {
	uri: string;
	focalPoint: FocalPoint;
	isResponsive: boolean;
};

export const FocalPointPreviewSection = (props: FocalPointPreviewSectionProps): ReactElement => {
	const {
		uri,
		focalPoint,
		isResponsive
	} = props;

	return (
		<div className={styles.root}>
			{!isResponsive && (
				<h3>{localize("_ThumbnailPreview")}</h3>
			)}
			<div className={styles.previewGrid}>
				<div className={styles.wide}>
					<p className={styles.subtitle}>{localize("_Wide")}</p>
					<div className={styles.previewImageContainer}>
						<ImageWithFocalPoint
							src={uri}
							focalPoint={focalPoint}
							height="fill"
						/>
					</div>
				</div>
				<div className={styles.ultraWide}>
					<p className={styles.subtitle}>{localize("_UltraWide")}</p>
					<div className={styles.previewImageContainer}>
						<ImageWithFocalPoint
							src={uri}
							focalPoint={focalPoint}
							height="fill"
						/>
					</div>
				</div>
				<div className={styles.portrait}>
					<p className={styles.subtitle}>{localize("_Portrait")}</p>
					<div className={styles.previewImageContainer}>
						<ImageWithFocalPoint
							src={uri}
							focalPoint={focalPoint}
							height="fill"
						/>
					</div>
				</div>
				<div className={styles.squared}>
					<p className={styles.subtitle}>{localize("_Squared")}</p>
					<div className={styles.previewImageContainer}>
						<ImageWithFocalPoint
							src={uri}
							focalPoint={focalPoint}
							height="fill"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
FocalPointPreviewSection.displayName = "FocalPointPreviewSection";